module.exports = __webpack_public_path__ + "img/Löschzug.962f39e1.svg";